import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "GoogleMapStreetviewWrapper",
  props: {
    address: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({
        address: this.address.toString()
      }, this.getCoordinates);
    },
    getCoordinates(results, status) {
      if (status === google.maps.StreetViewStatus.OK) {
        this.updateView(results[0].geometry.location);
      }
    },
    updateView(location) {
      const map = new google.maps.Map(document.getElementById("map"), {
        center: location,
        zoom: 17
      });
      let point = new google.maps.LatLng({
        lat: location.lat(),
        lng: location.lng()
      });
      let streetViewService = new google.maps.StreetViewService();
      let panorama = new google.maps.StreetViewPanorama(document.getElementById("pano"), {
        position: location,
        pov: {
          heading: 0,
          pitch: 0
        }
      });
      map.setStreetView(panorama);
      let markerPt = location;
      streetViewService.getPanorama({
        location: location,
        radius: 50
      }, function (results, status) {
        if (status === google.maps.StreetViewStatus.OK) {
          var _results$location;
          let oldPoint = location;
          if ((_results$location = results.location) != null && _results$location.latLng) {
            var _results$location2;
            point = (_results$location2 = results.location) == null ? void 0 : _results$location2.latLng;
          }
          markerPt = point;
          let heading = google.maps.geometry.spherical.computeHeading(point, oldPoint);
          panorama = new google.maps.StreetViewPanorama(document.getElementById("pano"), {
            position: point,
            pov: {
              heading: heading,
              pitch: 0
            },
            zoom: 1.5
          });
          map.setStreetView(panorama);
        }
        new google.maps.Marker({
          position: markerPt,
          map: map
        });
      });
    }
  }
});